export const TOTAL_DEFAULT_BANNER_PHOTOS = 4;

export const getDefaultBannerPhoto = () => {
  const randomIndex =
    Math.floor(Math.random() * TOTAL_DEFAULT_BANNER_PHOTOS) + 1;
  const defaultBannerPhotoPrefix = `https://baseballnearyou.s3.us-east-2.amazonaws.com/default_banner_images/${randomIndex}.jpg`;
  return defaultBannerPhotoPrefix;
};
